var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0.23 2.98 15.54 12.63"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.461 12.445V4.69c0-.631-.511-1.143-1.143-1.143H1.94c-.631 0-1.143.512-1.143 1.143v7.572c0 .631.512 1.143 1.143 1.143h.857M15.19 8.956h-4.73m3.19 4.236h.394c.631 0 1.143-.512 1.143-1.143V8.62l-1.591-3.257a1.14 1.14 0 0 0-1.027-.642h-1.905"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.447 15.035a1.595 1.595 0 1 0 0-3.19 1.595 1.595 0 0 0 0 3.19Zm7.243 0a1.595 1.595 0 1 0 0-3.19 1.595 1.595 0 0 0 0 3.19Zm-1.895-1.63H6.438"
  })));
};
export default SvgTruck;